import { CustomerService } from "../CustomerService";
import { DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutCustomerServiceMultiProfile extends Layout {
    layoutCustomerService: CustomerService;
    sourceCsmProfile: DataSource;
    sourceCustomerServiceMovements: DataSource;
    tabProfile: Tab;
    tabsetCustomerServiceProfiles: Tabset;
}
